import { useEffect, useState } from 'react'
import useFirstRender from '../../hooks/FirstRender';
import LoadMore from '../../components/common/LoadMore';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useApiProgress } from '../../hooks/ApiProgress';
import { ENTITY_IS_IN_USE_MESSAGE } from '../../utils/constants';
import { toast } from 'react-toastify';
import Input from '../../components/Input';
import { AiFillDelete, AiFillEdit } from 'react-icons/ai';
import Button from '../../components/Button';
import { GoPlus } from 'react-icons/go';
import { onChange } from '../../utils/functions';
import DeleteModal from '../../components/DeleteModal';
import { LOCATION_PATH, deleteLocation, getPageLocations } from '../../api/locationApi';
import { deleteLocationAction, getLocationPageAction, setLocationPageAction } from '../../redux/feature/locationSlice';

const LocationListPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const isFirstRender = useFirstRender()
    const nav = useNavigate()
    const dispatch = useDispatch()
    const locationPage = useSelector(state => state.location.page)
    const pendingApiCall = useApiProgress('get', `${LOCATION_PATH}/page`, false)
    const pendingApiCallDelete = useApiProgress('delete', `${LOCATION_PATH}`, false)
    const [searchParams, setSearchParams] = useState({
        id: "",
        code: "",
        name: "",
        description: ""
    })
    const [isOpen, setIsOpen] = useState(false)
    const [deleteId, setDeleteId] = useState(undefined)
    const [searchTimer, setSearchTimer] = useState();

    useEffect(() => {
        locationPage.content.length === 0 && loadLocations({ size: 20 })
    }, [])

    const onLoadMore = () => {
        if (!locationPage.last) {
            loadLocations({ ...searchParams, lastId: locationPage.content[locationPage.content.length - 1]?.id })
        }
    }

    useEffect(() => {
        !isFirstRender && searching(searchParams)
    }, [searchParams])

    const loadLocations = (params) => {
        !pendingApiCall &&
            getPageLocations(params)
                .then(res => {
                    dispatch(getLocationPageAction(res.data))
                })
    }

    const searching = async (params) => {
        if (searchTimer) clearTimeout(searchTimer);
        let timer = setTimeout(() => {
            getPageLocations(params)
                .then(res => {
                    dispatch(setLocationPageAction(res.data))
                })
        }, 500);
        setSearchTimer(timer);
    }

    const onClickDelete = () => {
        deleteLocation(deleteId)
            .then(res => {
                setIsOpen(false)
                dispatch(deleteLocationAction(res.data))
                toast.success('Silindi')
            }).catch(err => {
                toast.error(ENTITY_IS_IN_USE_MESSAGE)
            })
    }

    return (
        <div>
            <div className='mb-1 border-b border-zinc-300'>
                <label className='text-2xl'>
                    LOKASYONLAR
                </label>
            </div>
            <div className='flex gap-x-2 py-2 sticky top-0 bg-zinc-50'>
                <Button
                    text={<label className='flex items-center gap-x-1'><GoPlus />Yeni Lokasyon</label>}
                    variant='green'
                    onClick={() => nav('/location/add')}
                />
            </div>
            <table className='w-full text-left text-zinc-900 mb-10 text-sm'>
                <thead className='text-xs uppercase tracking-wide sticky top-12 bg-zinc-50'>
                    <tr>
                        <th className='p-2 w-1/12'>Id</th>
                        <th className='p-2 w-3/12'>Lokasyon Kodu</th>
                        <th className='p-2 w-3/12'>Lokasyon Adı</th>
                        <th className='p-2 w-4/12'>Açıklama</th>
                        <th className='p-2 w-1/12'>Aksiyon</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className='border-b items-center sticky top-20 bg-zinc-50'>
                        <td className='px-2'>
                            <Input
                                name="id"
                                placeholder='Id...'
                                onChange={e => onChange(e, setSearchParams)}
                            />
                        </td>
                        <td className='px-2'>
                            <Input
                                name="code"
                                placeholder='Lokasyon kodu...'
                                onChange={e => onChange(e, setSearchParams)}
                            />
                        </td>
                        <td className='px-2'>
                            <Input
                                name="name"
                                placeholder='Lokasyon adı...'
                                onChange={e => onChange(e, setSearchParams)}
                            />
                        </td>
                        <td>
                        </td>
                        <td>
                        </td>
                    </tr>
                    {
                        locationPage.content.map((location, index) => (
                            <tr key={index} className='border-b items-center hover:bg-violet-100 duration-150'>
                                <td className='p-2'># {location.id} </td>
                                <td className='p-2'>{location.code} </td>
                                <td className='p-2'>{location.name}</td>
                                <td className='p-2 '>{location.description}</td>
                                <td className='p-2 items-center'>
                                    <div className='flex gap-x-3'>
                                        <span className='cursor-pointer hover:scale-125 hover:text-blue-600 duration-150' onClick={() => nav(`/location/edit/${location.id}`)}>
                                            <AiFillEdit />
                                        </span>
                                        <span
                                            className='cursor-pointer hover:scale-125 hover:text-red-600 duration-150'
                                            onClick={() => {
                                                setIsOpen(true)
                                                setDeleteId(location.id)
                                            }}
                                        >
                                            <AiFillDelete />
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
            <LoadMore page={locationPage} pending={pendingApiCall} onLoadMore={onLoadMore} />
            <DeleteModal
                isOpen={isOpen}
                closeModal={() => setIsOpen(false)}
                onClick={onClickDelete}
                pendingApiCall={pendingApiCallDelete}
            />

        </div >
    )
}

export default LocationListPage